<div class="upcoming-tasks">
    <div class="header">
        <div class="title">
            <i class="fas fa-calendar-alt"></i>
            <span>Tasks</span>
        </div>
    </div>

    <div class="tasks-list">
        <div
            class="task-card"
            *ngFor="let task of tasks"
            (click)="openViewDetails(task)"
        >
            <div class="task-content">
                <div class="task-head">
                    <div class="task-title">{{ task.taskTitle }}</div>
                    <span class="status">{{ task.status }}</span>
                </div>
                <div class="task-row">
                    <img
                        src="/assets/img/dueDate.svg"
                        alt="calendar"
                        class="icon"
                    />
                    <span>{{
                        task.dueDateTime | date: 'yyyy-MM-dd HH:mm'
                    }}</span>
                </div>
                <div class="task-row">
                    <img
                        src="/assets/img/person.svg"
                        alt="assignee"
                        class="icon"
                    />
                    <span>{{ task.assigned }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- View Task Details Dialog -->
    <p-dialog
        [(visible)]="showViewDialog"
        [modal]="true"
        [dismissableMask]="true"
        [closable]="false"
        [position]="'center'"
        [baseZIndex]="3000"
        [blockScroll]="true"
        [appendTo]="'body'"
        [breakpoints]="{'960px': '95vw', '640px': '98vw'}"
        [style]="{width: '800px'}"
        [contentStyle]="{padding: '2rem', overflow: 'auto', maxHeight: '80vh'}"
    >
        <div class="text-left close-popup-pdialog" (click)="closeViewDialog()">
            <span class="fas fa-chevron-left"></span> Back
        </div>

        <div *ngIf="viewTaskData" class="task-details-content">
            <div class="task-details-header">
                <h2>{{ viewTaskData.title }}</h2>
                <span
                    class="task-status"
                    [class]="
                        viewTaskData.status.toLowerCase().replace(' ', '-')
                    "
                >
                    {{ viewTaskData.status }}
                </span>
            </div>

            <div class="task-details-grid">
                <div class="task-detail-item">
                    <label>Assigned To:</label>
                    <span>{{ viewTaskData.assignee || 'Unassigned' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Category:</label>
                    <span>{{ viewTaskData.category || 'No category' }}</span>
                </div>

                <div class="task-detail-item date-item">
                    <label>Start Date:</label>
                    <span>{{
                        viewTaskData.startDate | date: 'MMM dd, yyyy h:mm a'
                    }}</span>
                </div>

                <div class="task-detail-item date-item">
                    <label>Due Date:</label>
                    <span>{{
                        viewTaskData.dueDate
                            ? (viewTaskData.dueDate
                              | date: 'MMM dd, yyyy h:mm a')
                            : '-'
                    }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Created By:</label>
                    <span>{{ viewTaskData.createdBy || 'System' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Cycle:</label>
                    <span>{{ viewTaskData.cycle || '-' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Farm:</label>
                    <span>{{ viewTaskData.farm || 'Not specified' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>House:</label>
                    <span>{{ viewTaskData.house || 'Not specified' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Partition:</label>
                    <span>{{ viewTaskData.partition || '-' }}</span>
                </div>
            </div>

            <div
                *ngIf="viewTaskData.attachments?.length > 0"
                class="task-attachments"
            >
                <h4>Attachments</h4>
                <div class="attachment-list">
                    <div
                        *ngFor="let attachment of viewTaskData.attachments"
                        class="attachment-item"
                    >
                        <i class="fas fa-paperclip"></i>
                        <a [href]="attachment" target="_blank" rel="noopener noreferrer">{{
                            attachment.split('/').pop()
                        }}</a>
                    </div>
                </div>
            </div>

            <div *ngIf="viewTaskData.subTasks?.length > 0" class="sub-tasks">
                <h4>Sub Tasks</h4>
                <div class="sub-task-list">
                    <div
                        *ngFor="let subTask of viewTaskData.subTasks"
                        class="sub-task-item"
                    >
                        <div class="sub-task-header">
                            <h5>{{ subTask.title }}</h5>
                            <span
                                class="sub-task-status"
                                [class]="
                                    subTask.status
                                        .toLowerCase()
                                        .replace(' ', '-')
                                "
                            >
                                {{ subTask.status }}
                            </span>
                        </div>
                        <div class="sub-task-details">
                            <span
                                ><strong>Assignee:</strong>
                                {{ subTask.assignee }}</span
                            >
                            <span
                                ><strong>Due:</strong>
                                {{ subTask.dueDate | date: 'short' }}</span
                            >
                            <div
                                *ngIf="subTask.description"
                                class="sub-task-description"
                            >
                                <strong>Description:</strong>
                                {{ subTask.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
